import { render } from "./CustomHeader.vue?vue&type=template&id=54f37ce8&scoped=true"
import script from "./CustomHeader.vue?vue&type=script&lang=js"
export * from "./CustomHeader.vue?vue&type=script&lang=js"

import "./CustomHeader.vue?vue&type=style&index=0&id=54f37ce8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f37ce8"]])

export default __exports__